import React, {
    useContext,
    useEffect,
    useState,
} from 'react';
import * as Styled from './styled';
import Flag from '@components/flag';
import { useDispatch, useSelector } from 'react-redux';
import {
    getDetailedIso3,
    getDetailedTitle,
    getScarvesData,
    getDetailedDataItems,
} from '@containers/detailed/selectors';
import { useParams } from 'react-router-dom';
import { setDetailedInfo } from '@containers/detailed/actions';
import Modal from '@material-ui/core/Modal';
import { ThemeContext } from '@src/index';
import SportsImage from '@src/assets/sports.png';
import UltrasImage from '@src/assets/ultras.png';
import { getContributorsList } from '@containers/home/header/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import PlayerImage from '@src/assets/player.png';

const WIDTH_LOGO = [
    'https://api.mamikonyan.io/logos/germany/union_b.png',
    'https://api.mamikonyan.io/logos/russia/zenit.png',
    'https://api.mamikonyan.io/logos/japan/japan.png',
    'https://api.mamikonyan.io/logos/ultras/proud_eagles.png',
    'https://api.mamikonyan.io/logos/ultras/virage_sud.png',
    'https://api.mamikonyan.io/logos/austria/austria.png',
];

const Detailed = () => {
    const dispatch = useDispatch();

    const palette = useContext(ThemeContext);
    const { CARD_BACKGROUND_COLOR } = palette;

    const detailedIso3 = useSelector(getDetailedIso3);
    const detailedTitle = useSelector(getDetailedTitle);
    const categories = useSelector(getScarvesData);
    const detailedScarves = useSelector(
        getDetailedDataItems
    );
    const contributorsList = useSelector(
        getContributorsList
    );
    const { categorySlug } = useParams();

    const [isModalOpen, setModalOpen] = useState(false);
    const [scarfPath, setScarfPath] = useState('');
    const [contributor, setContributor] = useState('');
    const [isImageLoading, setImageLoading] =
        useState(true);

    const handleClose = () => {
        setModalOpen(false);
        setScarfPath('');
        setContributor('');
        setImageLoading(true);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!detailedIso3) {
            const singleCategory = categories.find(
                category => category.slug === categorySlug
            );

            if (singleCategory) {
                setDetailedInfo(dispatch, singleCategory);
            }
        }
    }, [detailedIso3, categories, categorySlug, dispatch]);

    return (
        <Styled.DetailedWrapper>
            <Styled.DetailedHeader>
                <Styled.BackButton
                    to="/"
                    $CARD_BACKGROUND_COLOR={
                        palette.CARD_BACKGROUND_COLOR
                    }
                    $CARD_BORDER_COLOR={
                        palette.CARD_BORDER_COLOR
                    }
                    $PRIMARY_FONT_COLOR={
                        palette.PRIMARY_FONT_COLOR
                    }
                    $isDarkMode={palette.isDarkMode}
                    onClick={() => {
                        // Reset detailed info if needed, or rely on Home component logic
                    }}
                >
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                    />
                </Styled.BackButton>
                <Styled.DetailedTitleBox
                    background={CARD_BACKGROUND_COLOR}
                >
                    {detailedIso3 === 'OTHR' ? (
                        <img
                            src={SportsImage}
                            alt="Other"
                            width={28}
                            height={28}
                        />
                    ) : detailedIso3 === 'ULTR' ? (
                        <img
                            src={UltrasImage}
                            alt="Ultras"
                            width={28}
                            height={28}
                        />
                    ) : detailedIso3 === 'PLYR' ? (
                        <img
                            src={PlayerImage}
                            alt="Player"
                            width={28}
                            height={28}
                        />
                    ) : (
                        <Flag
                            iso3={detailedIso3}
                            size={28}
                        />
                    )}
                    <Styled.DetailedHeaderText>
                        {detailedTitle}
                    </Styled.DetailedHeaderText>
                </Styled.DetailedTitleBox>
            </Styled.DetailedHeader>
            <Styled.DetailedBodyWrapper>
                {detailedScarves.map(
                    (singleScarf, index) => (
                        <Styled.DetailedCardWrapper
                            key={`${singleScarf.name}-${index}`}
                            onClick={() => {
                                setModalOpen(true);
                                setScarfPath(
                                    singleScarf.scarfPath
                                );
                                setContributor(
                                    contributorsList[
                                        singleScarf
                                            .contributor
                                    ].name
                                );
                            }}
                        >
                            <Styled.DetailedCardLogoWrapper>
                                <Styled.DetailedCardLogo
                                    widthBased={WIDTH_LOGO.includes(
                                        singleScarf.logoPath
                                    )}
                                    src={
                                        singleScarf.logoPath
                                    }
                                />
                            </Styled.DetailedCardLogoWrapper>
                            <Styled.DetailedCardTitle>
                                {singleScarf.name}
                            </Styled.DetailedCardTitle>
                        </Styled.DetailedCardWrapper>
                    )
                )}
            </Styled.DetailedBodyWrapper>

            <Modal
                open={isModalOpen}
                onClose={handleClose}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Styled.DetailedModalWrapper
                    $CARD_BORDER_COLOR={
                        palette.CARD_BORDER_COLOR
                    }
                    $MODAL_BACKGROUND_COLOR={
                        palette.MODAL_BACKGROUND_COLOR
                    }
                >
                    {isImageLoading && (
                        <Styled.ImageLoaderWrapper>
                            <Styled.ModalBlobLoader />
                        </Styled.ImageLoaderWrapper>
                    )}
                    <img
                        src={scarfPath}
                        alt=""
                        onLoad={() =>
                            setImageLoading(false)
                        }
                        style={{
                            display: isImageLoading
                                ? 'none'
                                : 'block',
                        }}
                    />
                    {!isImageLoading && contributor && (
                        <Styled.DetailedModalText
                            $PRIMARY_FONT_COLOR={
                                palette.PRIMARY_FONT_COLOR
                            }
                            $CARD_BORDER_COLOR={
                                palette.CARD_BORDER_COLOR
                            }
                            $isDarkMode={
                                palette.isDarkMode
                            }
                        >
                            from{' '}
                            <strong>{contributor}</strong>
                        </Styled.DetailedModalText>
                    )}
                </Styled.DetailedModalWrapper>
            </Modal>
        </Styled.DetailedWrapper>
    );
};

export default Detailed;
